module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/logo_edge.b91188346ae729d57d683a4577711071.svg";